import { createFileRoute } from '@tanstack/react-router'
import { ContactPage } from '@/components/pages/contact-page'

export const Route = createFileRoute('/contact')({
  component: ContactPage,
  head: () => ({ meta: [{ title: 'Contact — mkdn.app' }] }),
})
